import React, { Component } from "react";
import AnimateHeight from "react-animate-height";
import PropTypes from "prop-types";
import Card from "components/Card";

import "./ExpandingBox.css";

// in milliseconds
const ANIMATION_DURATION = 200;

/**
 * Two reasons for these components:
 * - We can search props.children for these component types
 * - We can control the onClick behaviour of the header and body separately
 */
class ExpandingBoxHeader extends Component {
  
  static propTypes = {
    toggleOnClick: PropTypes.bool
    // don't validate the onClick prop since it's not "public"
  }
  
  static defaultProps = {
    toggleOnClick: true
  }
  
  render() {
    const { toggleOnClick, onClick } = this.props;
    return (
      <div onClick={toggleOnClick ? onClick : undefined}>
        { this.props.children }
      </div>
    );
  }
  
}

class ExpandingBoxBody extends Component {
  
  static propTypes = {
    toggleOnClick: PropTypes.bool
  }
  
  static defaultProps = {
    toggleOnClick: false
  }
  
  render() {
    const { toggleOnClick, onClick } = this.props;
    return (
      <div onClick={toggleOnClick ? onClick : undefined}>
        { this.props.children }
      </div>
    );
  }
  
}

/**
 * Wraps a header and a body, and allows toggling the body in and out
 * Props override state, so if you are controlling the expansion externally, use the expanded prop
 * Otherwise, it can track its own state.
 */
export default class ExpandingBox extends Component {
  
  /**
   * Allow props.expanded to override state.expanded
   * If no `expanded` prop was provided then we leave the state alone
   * This prevents cases where a re-render would cause the box to collapse even
   *   when the `expanded` prop was not being used
   */
  static getDerivedStateFromProps(nextProps) {
    const { expanded } = nextProps;
    if (expanded !== undefined) {
      return { expanded }
    }
    return null;
  }
  
  state = {
    expanded: false
  }
  
  static Header = ExpandingBoxHeader;
  static Body = ExpandingBoxBody;

  static propTypes = {
    children: PropTypes.array.isRequired,
    onExpand: PropTypes.func,
    onCollapse: PropTypes.func,
    cssModifier: PropTypes.string,
    expanded:PropTypes.bool
  }

  static defaultProps = {
    onExpand: () => undefined,
    onCollapse: () => undefined,
  }
  
  expand = () => {
    this.setState({
      expanded: true
    })
    this.props.onExpand();
  }
  
  collapse = () => {
    this.setState({
      expanded: false
    })
    this.props.onCollapse();
  }

  render() {

    const { cssModifier, children } = this.props;
    const { expanded } = this.state;
    const currentStatus = expanded ? "expanded" : "collapsed";
    const bodyHeight = expanded ? "auto" : "0";
    const onClick = expanded ? this.collapse : this.expand;

    // Find the Header and Body sub-components from the children
    const header = children.filter(child => child.type === ExpandingBoxHeader)[0];
    const body = children.filter(child => child.type === ExpandingBoxBody)[0];

    // Combine default classes with custom modifiers
    const classNames = [ "expanding-box", `expanding-box--${currentStatus}` ];
    if(cssModifier !== undefined) {
      classNames.push(`expanding-box--${cssModifier}`);
    }

    return (
      <Card>
        <div className={classNames.join(" ")}>
          <Card.Body>
            { React.cloneElement(header, { onClick }) }
            <AnimateHeight duration={ANIMATION_DURATION} height={bodyHeight}>
              { React.cloneElement(body, { onClick }) }
            </AnimateHeight>
          </Card.Body>
          <div className="expanding-box__expander" onClick={onClick}>
            <div className="expanding-box__arrow"></div>
          </div>
        </div>
      </Card>
    );

  }

}



// WEBPACK FOOTER //
// ./src/components/ExpandingBox.js